import React from 'react';
import './UserPopup.less';
import PropTypes from 'prop-types';
import { push } from '../../utils';

interface IUserPopupPropType {
    prefixCls?: string;
}

class UserPopup extends React.Component<IUserPopupPropType, any> {
    static defaultProps = {
        prefixCls: 'user-popup'
    };

    static contextTypes = {
        router: PropTypes.object
    };

    render() {
        const {prefixCls} = this.props;
        return (
            <div>
                <div className={`${prefixCls}-cover`}/>
                <div className={`${prefixCls}-container`}>
                    <div className={`${prefixCls}-img`}>
                        <img src={require('../../images/error-user.png')} alt=""/>
                    </div>
                    <p className={`${prefixCls}-title`}>您已不是新用户啦！</p>
                    <p className={`${prefixCls}-msg`}>该商品为新用户专属，快去店铺查看更多优惠商品吧</p>
                    <div className={`${prefixCls}-btn`} onClick={() => {
                        push('/home', this);
                    }}>
                        去店铺首页
                    </div>
                </div>
            </div>
        );
    }
}

export default UserPopup;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/userPopup/UserPopup.tsx